import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { compose, prop } from 'ramda';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import wrapIn from 'app/enhancers/wrapIn';
import S from 'app/features/success/offerBlock/components/OfferBlock.styled';
import Heading from 'app/components/layout/Heading.styled';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import {
  isVisible,
  sectionTitle,
  imageUrl,
  imageUrl2X,
  redirectUrl,
} from 'app/features/success/offerBlock/selectors';

const UI = ({ sectionTitle, imageUrl, imageUrl2X, redirectUrl }) => (
  <article data-t="offer-block">
    <Heading as={S.OfferBlock.Title} size="l">
      <FormattedMessage id={sectionTitle} />
    </Heading>
    <a href={redirectUrl}>
      <S.BackgroundImage src={imageUrl} srcSet={`${imageUrl2X} 2x`} />
    </a>
  </article>
);

UI.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  imageUrl2X: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string.isRequired,
};

UI.displayName = 'OfferBlock';

const OfferBlock = compose(
  connect({ isVisible, sectionTitle, imageUrl, imageUrl2X, redirectUrl }),
  renderIf(prop('isVisible')),
  wrapIn(BlockWrapper),
)(UI);

export { UI };

export default OfferBlock;
